//import {func, number} from 'prop-types';
import ReactPaginate from 'react-paginate';
import PrevArrowIcon from "./PrevArrowIcon";
import NextArrowIcon from "./NextArrowIcon";

const Paginate = ({pageCount, onPageChange}) =>{
    
    return(
        <ReactPaginate
            previousLabel={ <PrevArrowIcon />}
            nextLabel={ <NextArrowIcon />}
            breakLabel={'...'}
            breakClassName={'page-item'}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={15}
            onPageChange={onPageChange}
            containerClassName={'pagination justify-content-center mb-3'}
            activeClassName={'active'}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLinkClassName="page-link"      
            initialPage={0}                                  
        />
    );
}

// Define the prop types for the Pagination component
/*Paginate.propTypes = {
  initialPage: number.isRequired, // The initial page is required and must be a number
  pageCount: number.isRequired, // The total number of pages is required and must be a number
  onPageChange: func.isRequired, // The function to call when the page changes is required
};*/

export default Paginate;